import { Navigate } from '@shared/enums/navigate';

import Mail from '@public/icons/mail.svg';
import Phone from '@public/icons/phone.svg';
import Facebook from '@public/icons/facebook.svg';
import LinkedIn from '@public/icons/linked-in.svg';
import Instagram from '@public/icons/instagram.svg';
import { NavItem } from '@shared/interfaces/navigate';
import { EMAIL, PHONE_NUMBER } from '@shared/constants/base';

export const HOME = '/';
export const JOIN = 'join';
export const THANK_YOU = '/thank-you';
export const PRIVACY_POLICY = '/privacy-policy';
export const TERMS_AND_CONDITIONS = '/terms-and-conditions';

export const navigation: NavItem[] = [
  { href: 'about', title: Navigate.About, sortOrder: 1 },
  { href: 'locations', title: Navigate.Locations, sortOrder: 2 },
  { href: 'review', title: Navigate.Services, sortOrder: 3 },
  { href: 'partners', title: Navigate.Partners, sortOrder: 4 },
];

export const socialNavigation: NavItem[] = [
  {
    href: `tel:${PHONE_NUMBER.phone}`,
    ariaLabel: 'Call us',
    Icon: Phone,
    sortOrder: 1,
  },
  {
    href: `mailto:${EMAIL}`,
    ariaLabel: 'Email us',
    Icon: Mail,
    sortOrder: 2,
  },
  {
    href: 'https://www.linkedin.com/company/green-line-logistics-inc/',
    ariaLabel: 'LinkedIn',
    target: '_blank',
    Icon: LinkedIn,
    sortOrder: 3,
  },
  {
    href: 'https://www.facebook.com/GreenlineLogisticsInc/',
    ariaLabel: 'Facebook',
    target: '_blank',
    Icon: Facebook,
    sortOrder: 4,
  },
  {
    href: 'https://www.instagram.com/greenlinelog/',
    ariaLabel: 'Instagram',
    target: '_blank',
    Icon: Instagram,
    sortOrder: 5,
  },
];
